import { defineComponent as _defineComponent } from 'vue';
import { BOverlay } from 'bootstrap-vue';
import debounce from 'lodash/debounce';
import { computed, onMounted, ref, watch } from 'vue';
import { getSheetPrice } from 'public/modules/pricing';
import { validateSheet } from 'public/modules/validation';
import { sheetDelivery } from 'public/modules/delivery';
export default /*#__PURE__*/ _defineComponent({
    __name: 'GlazingOption',
    props: {
        glazing: null,
        frameSize: null,
        basePrice: null,
        groupId: null,
        included: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const price = ref('0.00');
        const loading = ref(true);
        const manufacture = ref({ isValid: true, problems: [], warnings: [] });
        const delivery = ref({ isValid: true, problems: [], warnings: [] });
        const updatePrice = async () => {
            const p = await getSheetPrice(`G-${props.glazing.id}`, props.frameSize, true, props.groupId);
            price.value = p.base_unit_price;
        };
        const validateManufacture = async () => {
            manufacture.value = await validateSheet(`G-${props.glazing.id}`, props.frameSize);
        };
        const validateDelivery = async () => {
            delivery.value = await sheetDelivery(props.glazing.sku, props.frameSize, true);
        };
        const update = async () => {
            loading.value = true;
            await Promise.all([updatePrice(), validateManufacture(), validateDelivery()]);
            loading.value = false;
        };
        const diffInPrice = computed(() => {
            const diff = parseFloat(price.value.replace(/,/g, '')) - parseFloat(props.basePrice);
            const sign = diff > 0 ? '+' : '';
            return `${sign}\u00a3${diff.toFixed(2)}`;
        });
        const debouncedUpdatePrice = debounce(update, 350);
        watch(() => props.frameSize, () => debouncedUpdatePrice(), { deep: true });
        onMounted(() => { update(); });
        return { __sfc: true, props, price, loading, manufacture, delivery, updatePrice, validateManufacture, validateDelivery, update, diffInPrice, debouncedUpdatePrice, BOverlay, debounce, computed, onMounted, ref, watch, getSheetPrice, validateSheet, sheetDelivery };
    }
});
